module.exports = __webpack_public_path__ + "static/media/about-img.ab2f2a41.png";